import './global.css';

export {default as wrapRootElement} from '/src/store/ReduxWrapper.js';

export const shouldUpdateScroll = () => false